import { TextFieldProps } from '@lifeomic/chroma-react/components/TextField';
import { FieldProps, getIn } from 'formik';
import React from 'react';
import { MaskedInputProps } from 'react-text-mask';
import MaskedTextField from './MaskedTextField';

export interface FormikMaskedTextFieldOwnProps {
  input?: TextFieldProps;
}

export type FormikMaskedTextFieldProps = FormikMaskedTextFieldOwnProps &
  FieldProps &
  Omit<MaskedInputProps, 'form'>;

const FormikMaskedTextField: React.FC<FormikMaskedTextFieldProps> = ({
  form: { isSubmitting, touched, errors },
  // field gives us things like `name`, `onChange, `onBlur`, etc.
  field,
  input = {},
  ...rootProps
}) => {
  const fieldError = getIn(errors, field.name);
  const showError = getIn(touched, field.name) && !!fieldError;
  const inputToPass: TextFieldProps = {
    ...input,
    hasError: showError,
    errorMessage: showError && fieldError,
    disabled: input.disabled || isSubmitting,
  };

  return <MaskedTextField {...field} {...rootProps} input={inputToPass} />;
};

export default FormikMaskedTextField;
